import { createSSRApp, type Component } from 'vue';
import type { GetPageData } from '@/types/index.mts';

const getClientPageData: GetPageData = (origin = document, pageDataId = 'modelData') => {
  const model = origin.getElementById(pageDataId);
  return model === null ? { pageData: {} } : JSON.parse(model.innerHTML);
};

const renderComponent = (root: Element | string, component: Component) => {
  const { pageData: props } = getClientPageData();
  const app = createSSRApp(component, props);

  app.mount(root);
};

const waitForElement = (selector: string) => new Promise<Element>((resolve) => {
  if (document.querySelector(selector)) {
    resolve(document.querySelector(selector)!);
  }

  const observer = new MutationObserver(() => {
    if (document.querySelector(selector)) {
      resolve(document.querySelector(selector)!);
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

/**
 * Should we prevent default?
 * Only if left-clicked, and link is provided (intentional)
 * @param event - click event
 * @param link - url or undefined
 */
const shouldPreventDefault = (event?: KeyboardEvent | MouseEvent, link?: string) => {
  if (event
    && (event?.target as HTMLAnchorElement)?.href
    && event.which === 1
    && !event.altKey
    && !event.ctrlKey
    && !event.metaKey
    && !event.shiftKey
    && link
  ) { return true; }
  return false;
};

/**
 * navigate to link
 *
 * @param link - url to navigate to
 */
const navigate = (link: string) => {
  window.location.href = link;
};

export {
  getClientPageData,
  renderComponent,
  waitForElement,
  shouldPreventDefault,
  navigate,
};
